module.exports = __webpack_public_path__ + "img/back_icon.82a28303.png";